<template>
    <Fragment>
        <SpinnerItem v-if="isLoading" />
        <form v-if="!isLoading" @submit="submit">
            <ImageContainer :pictures="region.images" ownerType="region" />
            <div class="field">
                <label class="label">Navn</label>
                <input
                    v-model="region.name"
                    class="input text"
                    type="text"
                    placeholder="Navn"
                    required
                />
            </div>
            <div class="field">
                <label class="label">Beskrivelse</label>
                <textarea v-model="region.description" placeholder="Hvor er dette?" class="input" />
            </div>
            <div class="field">
                <button type="submit" class="button">Lagre region</button>
            </div>
        </form>
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { Bus, Stops } from '../../common/bus';
import api from '../../common/api';
import url from '../../common/url';
import SpinnerItem from '../common/SpinnerItem.vue';
import ImageContainer from '../common/ImageContainer.vue';

export default {
    props: ['id'],
    components: { Fragment, SpinnerItem, ImageContainer },
    data() {
        return {
            isLoading: false,
            region: {
                name: null,
                description: null,
                images: [],
            },

        };
    },
    created() {
        Bus.$emit(Stops.NAVBAR, 'None');
        if (this.id) this.loadRegion(this.id);
    },
    methods: {
        async loadRegion(id) {
            this.isLoading = true;
            const region = await api.get(url.getRegion(id));
            this.isLoading = false;
            if (region.error) return;
            this.region = region;
        },
        async submit(event) {
            event.preventDefault();
            this.isLoading = true;
            let region = null;
            region = await api.put(url.getRegion(this.id), this.region);
            this.isLoading = false;
            if (region.error) return;
            this.region = region;
            Bus.$emit(Stops.TOAST, 'Region lagret');
            Bus.$emit(Stops.UPLOAD_IMAGE, { ownerId: region.id });
            this.$router.push({ name: 'RegionPage' });
        },
    },
};
</script>

<style lang="scss" scoped>
form {
    display: flex;
    max-width: $maxContentWidth/3;
    font-size: 1.2rem;
    flex-direction: column;
    text-align: center;
    margin: auto;
    .field {
        padding: 0.3rem;
        display: flex;
        flex-direction: column;
        line-height: 2rem;
        width: 100%;
        text-align: left;
        .input {
            width: 100%;
            padding: 0.5rem 0.5rem 0.5rem 0.6rem;
            margin: 0.2rem 0;
            border: 1px solid $borderColor;
            border-radius: 4px;
            line-height: 1.4rem;
            box-sizing: border-box;
            transition: all 0.2s ease-in-out;
            &:hover {
                border: 1px solid $borderColorActive;
            }
        }
    }
}
</style>
